export const HEADER_COLUMNS = [
  'Reopen Request',
  'Type',
  'Request Number',
  'From Site',
  'Ship From Address',
  'To Site',
  'Status',
  'Creation Date',
  'Tracking Number',
  'Tracking Status',
  'Expected Delivery Date',
  'Delivered Date',
  'BU',
  'Received At RAD'
] as const;

export const LINE_COLUMNS = [
  'Edit',
  'Description',
  'Serial Number',
  'Asset Number',
  'Item Number',
  'Validated Serial Number',
  'Pallet',
  'Subinventory',
  'Cage',
  'Tote',
  'Receiving Status',
  'Tracking Number',
  'Replacement Order',
  'ISO Status',
  'Repair Eligibility',
  'RAD Receipt Date'
] as const;